var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    "class": _vm.rootClass
  }, [_c(_vm.nameTag, {
    tag: "component",
    "class": _vm.nameClass
  }, [_vm._v(_vm._s(_vm.name))]), _vm.displayOwner ? _c(_vm.ownerTag, {
    tag: "component",
    "class": _vm.ownerClass
  }, [_vm._v(" " + _vm._s(_vm.displayOwner) + " ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }